import { z } from 'zod';

import { idSchema, isoDateSchema, jsonMetaSchema } from './common.schema';

export const subscriptionStatusSchema = z.enum([
  'trialing',
  'active',
  'past_due',
  'canceled',
  'paused',
  'archived',
]);
export const paymentProviderSchema = z.enum(['yookassa', 'stripe', 'sbp', 'invoice', 'manual']);

/** Plan record (full row из таблицы plans). Имя `planRecordSchema` чтобы не конфликтовать с workspace.planSchema (enum). */
export const planRecordSchema = z.object({
  id: idSchema,
  code: z.enum(['free', 'starter', 'business', 'enterprise']),
  name: z.string(),
  price_minor: z.number().int().nonnegative(),
  currency: z.string(),
  limits: jsonMetaSchema,
  features: jsonMetaSchema,
  overage_price_minor: z.number().int().nonnegative(),
  is_active: z.boolean(),
});
export type PlanRecord = z.infer<typeof planRecordSchema>;

export const subscriptionSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  plan_id: idSchema.nullable(),
  status: subscriptionStatusSchema,
  billing_cycle: z.enum(['monthly', 'yearly']),
  active_seats: z.number().int().nonnegative(),
  overage_policy: z.enum(['block', 'charge', 'notify']),
  payment_provider: paymentProviderSchema.nullable().optional(),
  trial_ends_at: isoDateSchema.nullable().optional(),
  current_period_start: isoDateSchema.nullable().optional(),
  current_period_end: isoDateSchema.nullable().optional(),
  canceled_at: isoDateSchema.nullable().optional(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Subscription = z.infer<typeof subscriptionSchema>;

export const changePlanSchema = z.object({
  plan_code: z.enum(['free', 'starter', 'business', 'enterprise']),
  billing_cycle: z.enum(['monthly', 'yearly']).default('monthly'),
});

export const invoiceSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  subscription_id: idSchema.nullable().optional(),
  number: z.string(),
  amount_minor: z.number().int(),
  currency: z.string(),
  status: z.enum(['open', 'paid', 'failed', 'refunded']),
  line_items: z.array(jsonMetaSchema),
  issued_at: isoDateSchema,
  due_at: isoDateSchema.nullable().optional(),
  paid_at: isoDateSchema.nullable().optional(),
  pdf_url: z.string().url().nullable().optional(),
});
